import React from "react";
import Hero from "@/components/site/Hero";
import LogoMarquee from "@/components/site/LogoMarquee";
import Services from "@/components/site/Services";
import PlatformFeatures from "@/components/site/PlatformFeatures";
import HowItWorks from "@/components/site/HowItWorks";
import Benefits from "@/components/site/Benefits";
import CustomerTypes from "@/components/site/CustomerTypes";
import Compliance from "@/components/site/Compliance";
import Testimonials from "@/components/site/Testimonials";
import CTASection from "@/components/site/CTASection";
import SectionNav from "@/components/site/SectionNav";

export default function Home() {
  return (
    <>
      <SectionNav />
      <Hero />
      <LogoMarquee />
      <Services />
      <PlatformFeatures />
      <HowItWorks />
      <Benefits />
      <CustomerTypes />
      <Compliance />
      <Testimonials />
      <CTASection />
    </>
  );
}
